import { connectedStore } from '../../store';
import cutElementAction from '../actions/cut-element';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const cutElement = (elementId, options) => {
  const store = connectedStore.get();
  store.dispatch(cutElementAction(elementId, options));
};

cutElement[USED_ACTION_CREATOR] = cutElementAction;

export default cutElement;
